import { DashboardOutlined, ExpandLess, ExpandMore } from "@mui/icons-material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import * as React from "react";
import { BiBookAlt, BiCustomize, BiDollarCircle } from "react-icons/bi";
import { CgNotes } from "react-icons/cg";
import { FiSettings, FiUser } from "react-icons/fi";
import { HiOutlineLogout } from "react-icons/hi";
import { MdOutlineQuiz } from "react-icons/md";
import { NavLink, useHistory } from "react-router-dom";
import { VscCreditCard } from "react-icons/vsc";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import { toast } from "react-toastify";
import "./css/sidebarMenu.css";
import CreateQuiz from "admin/Quiz/CreateQuiz";
import MenuBookIcon from '@mui/icons-material/MenuBook';
import FolderIcon from "@mui/icons-material/Folder";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const AdminSidebarMenu = ({ url, handleMenuClick }) => {
  const [quizSubmenu, setQuizSubmenu] = React.useState(false);
  const [coursesSubmenu, setCoursesSubmenu] = React.useState(false);
  const [settingSubMenu, setSettingsSubmenu] = React.useState(false);
  const [userSubMenu, setUserSubMenu] = React.useState(false);
  const [donationSubmenu, setDonationSubmenu] = React.useState(false);
  const [instructorSubMenu, setInstructorSubMenu] = React.useState(false);
  const [earningSubMenu, setEarningSubMenu] = React.useState(false);
  const [chatSubMenu, setChatSubMenu] = React.useState(false);
  const history = useHistory();
  const handleClick = () => {
    setQuizSubmenu(!quizSubmenu);
  };
  const handleClick1 = () => {
    setCoursesSubmenu(!coursesSubmenu);
  };
  const handleClick2 = () => {
    setSettingsSubmenu(!settingSubMenu);
  };
  const handleClick3 = () => {
    setUserSubMenu(!userSubMenu);
  };
  const handleClick4 = () => {
    setDonationSubmenu(!donationSubmenu);
  };
  const handleClick5 = () => {
    setInstructorSubMenu(!instructorSubMenu);
  };
  const handleClick7 = () => {
    setEarningSubMenu((prev) => !prev);
  };
  const handleClickChat = () => {
    setChatSubMenu((prev) => !prev);
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [directorySubmenu, setDirectorySubmenu] = React.useState(false);
  const handleClickDirectory = () => setDirectorySubmenu(!directorySubmenu);

  return (
    <div className="w-full mx-auto p-4"
    >
      <div>
        {/* <Button onClick={handleOpen}>Open modal</Button> */}
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              className="logout_title"
            >
              <span
                class="material-icons-outlined"
                style={{ marginRight: "5px", color: "#FAAD14" }}
              >
                error_outline
              </span>
              Log Out
            </Typography>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
              className="logout_text"
            >
              Are you sure you want to log out?
            </Typography>

            <div className="logout_confirm_btns">
              <Button
                variant="outlined"
                style={{
                  background: "#E6F0FF",
                  borderRadius: "2px",
                  color: "#18498B",
                  margin: "5px",
                  width: "51px",
                  height: "32px",
                }}
              >
                Back
              </Button>

              <Button
                variant="contained"
                style={{
                  background: "#18498B",
                  borderRadius: "2px",
                  margin: "5px",
                  width: "51px",
                  height: "32px",
                }}
              >
                OK
              </Button>
            </div>
          </Box>
        </Modal>
      </div>

      {/* dashboard */}
      <div className="w-full space-y-2 p-2  text-gray-800">
        {/* Dashboard */}
        <NavLink
          to={`${url}`}
          activeClassName="activeMenu"
          onClick={handleMenuClick}
        >
          <div className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-gray-100 transition cursor-pointer border-b border-gray-200 md:border-none">
            <div className="hidden md:block">
              <DashboardOutlined className="text-blue-800 w-5 h-5" />
            </div>
            <span className="">Dashboard</span>
          </div>
        </NavLink>

        {/* ID Card */}
        <NavLink
          to={`${url}/ID-CARD`}
          activeClassName="activeMenu"
          onClick={handleMenuClick}
        >
          <div className="flex items-center space-x-3 px-3 py-2 rounded-lg hover:bg-gray-100 transition cursor-pointer border-b border-gray-200 md:border-none">
            <div className="hidden md:block">
              <AccountBoxIcon className="text-lg text-blue-800" />

            </div>
            <span>ID Card</span>
          </div>
        </NavLink>

        {/* Directory */}
        <div
          onClick={handleClickDirectory}
          className="flex items-center justify-between px-3 py-2 rounded-lg hover:bg-gray-100 transition cursor-pointer border-b border-gray-200 md:border-none"
        >
          <div className="flex items-center space-x-3">
            <div className="hidden md:block">

              <FolderIcon className="text-blue-900" />
            </div>
            <span>Directory</span>
          </div>
          <div className="hidden md:block">
            {directorySubmenu ? <ExpandLess /> : <ExpandMore />}
          </div>

        </div>

        {/* Directory Submenu */}
        {directorySubmenu && (
          <div className="ml-10 space-y-2">
            <NavLink
              to={`${url}/create-directory`}
              activeClassName="activeMenu"
              onClick={handleMenuClick}
            >
              <div className="  p-2 rounded-2xl hover:bg-gray-100 border-b border-gray-200 ">Create Directory</div>
            </NavLink>
            <NavLink
              to={`${url}/edit-directory`}
              activeClassName="activeMenu"
              onClick={handleMenuClick}
            >
              <div className="p-2 rounded-2xl hover:bg-gray-100  border-b border-gray-200">Edit Directory</div>
            </NavLink>
          </div>
        )}

        {/* Courses */}
        <div
          onClick={handleClick1}
          className="flex items-center justify-between px-3 py-2 rounded-lg hover:bg-gray-100 transition cursor-pointer border-b border-gray-200 md:border-none"
        >
          <div className="flex items-center space-x-3 ">
            <div className="hidden md:block">
              <BiBookAlt className="text-blue-900 text-xl" />

            </div>
            <span>Courses</span>
          </div>
          <div className="hidden md:block">
            {coursesSubmenu ? <ExpandLess /> : <ExpandMore />}
          </div>

        </div>

        {/* Courses Submenu */}
        {coursesSubmenu && (
          <div className="ml-10 space-y-2">
            <NavLink
              to={`${url}/courses/create`}
              activeClassName="activeMenu"
              onClick={handleMenuClick}
            >
              <div className="p-2 rounded-2xl hover:bg-gray-100 border-b border-gray-200">View Courses</div>
            </NavLink>
          </div>
        )}

        {/* Users */}
        <div
          onClick={handleClick3}
          className="flex items-center justify-between px-3 py-2 rounded-lg hover:bg-gray-100 transition cursor-pointer border-b border-gray-200 md:border-none"
        >
          <div className="flex items-center space-x-3">
            <div className="hidden md:block">
              <FiUser className="text-blue-900 text-xl" />
            </div>
            <span>User</span>
          </div>
          <div className="hidden md:block">
            {userSubMenu ? <ExpandLess /> : <ExpandMore />}
          </div>
        </div>

        {/* User Submenu */}
        {userSubMenu && (
          <div className="ml-10 space-y-2">
            <NavLink
              to={`${url}/users/verification`}
              activeClassName="activeMenu"
              onClick={handleMenuClick}
            >
              <div className="p-2 rounded-2xl hover:bg-gray-100  border-b border-gray-200">User Verification</div>
            </NavLink>
            <NavLink
              to={`${url}/users/details`}
              activeClassName="activeMenu"
              onClick={handleMenuClick}
            >
              <div className="p-2 rounded-2xl hover:bg-gray-100  border-b border-gray-200">User Details</div>
            </NavLink>
            <NavLink
              to={`${url}/users/changes`}
              activeClassName="activeMenu"
              onClick={handleMenuClick}
            >
              <div className="p-2 rounded-2xl hover:bg-gray-100  border-b border-gray-200">Users Change Requests</div>
            </NavLink>
          </div>
        )}

        {/* Earnings */}
        <NavLink
          to={`${url}/transactions/earnings`}
          activeClassName="activeMenu"
          onClick={handleMenuClick}
        >
          <div className="ml-6 p-2 rounded-2xl hover:bg-gray-100  border-b border-gray-200">Earnings</div>
        </NavLink>
      </div>

    </div>
  );
};

export default AdminSidebarMenu;
